const GFLiveTotal = () => {
    (function () {
        var donationFormIds = [4, 32, 38, 94];

        /**
         * Check whether the form should use the custom live total.
         *
         * @param {number|string} formId The Gravity Forms form ID.
         * @returns {boolean}
         */
        function isDonationForm(formId) {
            return donationFormIds.indexOf(parseInt(formId, 10)) !== -1;
        }

        /**
         * Update all custom live total text instances for a Gravity Form.
         *
         * @param {number} formId The Gravity Forms form ID.
         * @param {number|string} total The current total value.
         */
        function updateLiveTotal(formId, total) {
            if (!isDonationForm(formId)) {
                return;
            }

            var formWrapper = document.getElementById('gform_wrapper_' + formId);

            if (!formWrapper) {
                return;
            }

            var totalOutputs = formWrapper.querySelectorAll('.gform__live-total');

            if (!totalOutputs.length) {
                return;
            }

            var totalValue = '';

            if (typeof total !== 'undefined' && total !== null) {
                totalValue = '£' + parseFloat(total).toFixed(2);
            }

            if (!totalValue) {
                return;
            }

            totalOutputs.forEach(function (totalOutput) {
                totalOutput.textContent = totalValue;
            });
        }

        document.addEventListener('gform/theme/scripts_loaded', function () {
            // eslint-disable-next-line no-undef
            if (typeof gform === 'undefined' || typeof gform.addFilter !== 'function') {
                return;
            }

            // eslint-disable-next-line no-undef
            gform.addFilter('gform_product_total', function (total, formId) {
                updateLiveTotal(formId, total);
                return total;
            });
        });

        document.addEventListener('gform/post_init', function (event) {
            var formId = event.detail.formId;

            if (!isDonationForm(formId)) {
                return;
            }

            updateLiveTotal(formId);
        });
    })();
};

export default GFLiveTotal;
